<template>
  <div
    class="buy-set_with-text"
    @click="handleBuySet"
  >
    <img
      alt="shopping"
      src="~/assets/img/svg/common/shopping.svg"
      class="buy-set__cart-icon"
    />
    <span class="buy-set__text">Купить комплект с фото #1</span>
  </div>
</template>

<script setup lang="ts">
const $emits = defineEmits(['buySet'])
const handleBuySet = () => {
  $emits('buySet');
}
</script>

<style scoped lang="scss">
.buy-set_with-text {
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
  cursor: pointer;
  &:hover {
    & > .buy-set__text {
      text-decoration: underline;
    }
    & > .buy-set__cart-icon {
      transform: scale(1.1);
    }
  }
}
.buy-set__cart-icon {
  transition: transform 0.2s ease;
  width: 20px;
  height: 20px;
  filter: invert(73%) sepia(0%) saturate(21%) hue-rotate(134deg) brightness(90%) contrast(84%);
}
.buy-set__text {
  font-weight: 600;
  font-size: 16px;
  line-height: 1.4;
  color: var(--silver);
}
</style>
